import { render, staticRenderFns } from "./PeriodeTotal.vue?vue&type=template&id=57fdbdc2&scoped=true"
import script from "./PeriodeTotal.vue?vue&type=script&lang=js"
export * from "./PeriodeTotal.vue?vue&type=script&lang=js"
import style0 from "./PeriodeTotal.vue?vue&type=style&index=0&id=57fdbdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdbdc2",
  null
  
)

export default component.exports